'use strict';

var scrollAnimate = require('base/components/scrollAnimate');
var clientSideValidation = require('core/components/clientSideValidation');
const cookieUtil = require('core/components/utilhelper');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
  $.spinner().stop();
  const $homeEmailSignup = $('.home-email-signup');
  const $emailSignupInput = $('.email-signup-input');
  const $input = $emailSignupInput.find('input');
  $homeEmailSignup.find('.error-container .error').remove();
  $emailSignupInput.removeClass('error');

  if ($('.email-signup-message-footer').length === 0) {
    $emailSignupInput.append('<div class="email-signup-message-footer"></div>');
  }
  if (data.success) {
    $('.email-signup-message-footer').append(
      '<div class="d-flex align-items-center alert-success"><span class="success-content-ave">' +
        data.msg +
        '<span class="svg-21-avenue-thick-success-dims svg-21-avenue-thick-success success-img"></span></span></div>'
    );
    $emailSignupInput.addClass('success');
    $input.next('span').remove();
    $('.email-input-box').find('.error-container .error').remove();
    button.closest('.signup-wrap').find('input,label,button').addClass('invisible');
    button.closest('form').find('.sign-up-bottom').addClass('invisible');
    setTimeout(function () {
      $('.email-signup-message-footer').remove();
      $emailSignupInput.removeClass('success');
      $input.val(''); // remove the email prefill as he has already submitted
      $input.siblings('label').removeClass('input-focus');
      button.closest('.signup-wrap').find('input,label,button').removeClass('invisible');
      button.closest('form').find('.sign-up-bottom').removeClass('invisible');
      button.removeAttr('disabled');
      $input.next('span').remove();
      $('.email-input-box').find('.error-container .error').remove();
    }, 3000);
  } else {
    const $homeEmailSignupContainer = $homeEmailSignup.length ? $homeEmailSignup : $('.footer-email-signup');

    if ($homeEmailSignupContainer.find('.error-container span.error').length === 0 && !$input.hasClass('is-invalid')) {
      $homeEmailSignupContainer.find('.error-container').append('<span class="error">' + data.msg + '</span>');
    } else {
      $input.siblings('span').remove();
      $homeEmailSignupContainer.find('.error-container span.error').html(data.msg);
    }

    if ($input.next('span').length === 0) {
      $('<span class="invalid"></span>').insertAfter($input);
    }
    $emailSignupInput.addClass('error');
    button.removeAttr('disabled');
  }
}

function welcomeToastNitification (element, message) {
  let errorHtml =
    '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
    'fade show" role="alert">' +
    '<button type="button" class="close welcome-toast" data-dismiss="alert" aria-label="Close">' +
    '</button>' +
    '<span class="error-content">'+ message +'</span>'+
    '</div>';
  $(element).html(errorHtml);
  $(element).addClass('show');
  setTimeout(() => {
    $(element).removeClass('show');
  }, 6000);
  $(element).find('button.welcome-toast').on('click', function () {
    $(element).removeClass('show');
  });
}

module.exports = function () {
  const $body = $('body');
  $(window).scroll(function () {
    if ($(window).scrollTop() > 100) {
      $('.back-to-top').addClass('active');
    } else $('.back-to-top').removeClass('active');
  });

  $('.back-to-top').click(function () {
    scrollAnimate();
  });

  $('.subscribe-email').on('click', function (e) {
    e.preventDefault();
    const $button = $(this);
    const url = $button.data('href');
    const emailId = $('input[name=hpEmailSignUp]').val();
    const reg = /^[A-Za-z0-9][\w\-\+%]*(\.[\w\-\+%]+)*@[A-Za-z0-9]([\w\.\-]*[A-Za-z0-9])?\.[A-Za-z]{2,}$/;
    if (!reg.test(emailId)) {
      if ($('.email-input-box').find('.error-container .error').length) {
        $('.email-signup-input').find('input').removeClass('is-invalid');
      }
      return false;
    }
    $.spinner().start();
    $button.attr('disabled', true);
    $.ajax({
      url: url,
      type: 'post',
      dataType: 'json',
      data: {
        emailId: emailId
      },
      success: function (data) {
        displayMessage(data, $button);
        if (data.success) {
          $body.trigger('adobeTagManager:emailsignupmodal', 'footer');
          if (data.subscribedEmailSHA256) {
            cookieUtil.setCookie("saks_email_hash", data.subscribedEmailSHA256, 365);
            window.pageData.visitor.SHA256_hash_email_address = data.subscribedEmailSHA256;
          }
        }
      },
      error: function (err) {
        displayMessage(err, $button);
      }
    });
  });

  $('.signup-wrap').on('input', '.email-signup-input input', function () {
    const $this = $(this);

    const reg = /^[A-Za-z0-9][\w\-\+%]*(\.[\w\-\+%]+)*@[A-Za-z0-9]([\w\.\-]*[A-Za-z0-9])?\.[A-Za-z]{2,}$/;

    if (($this.val() == 0 || !reg.test($this.val())) && $this.parent().hasClass('error')) {
      $this.next('span').remove();
      $this.closest('.email-input-box').find('.error-container span').remove();
      $this.parent().removeClass('error');
    }
  });

  $body.on('click', '.chat-now-link', function () {
    if (typeof embeddedservice_bootstrap !== 'undefined' && embeddedservice_bootstrap.utilAPI && window.saksAgentforceReady) {
      embeddedservice_bootstrap.utilAPI.launchChat();
      sessionStorage.setItem('saks_agentforce_active', 'true');
    } else {
      var waitCount = 0;
      var waitLimit = 50; // 50 × 200ms = 10s; widget init is async after lazy script load
      var waitForWidget = setInterval(function () {
        waitCount += 1;
        if (typeof embeddedservice_bootstrap !== 'undefined' && embeddedservice_bootstrap.utilAPI && window.saksAgentforceReady) {
          clearInterval(waitForWidget);
          embeddedservice_bootstrap.utilAPI.launchChat();
          sessionStorage.setItem('saks_agentforce_active', 'true');
        }
        if (waitCount >= waitLimit) {
          clearInterval(waitForWidget);
        }
      }, 200);
    }
  });

  $('.footer-email-signup input[name=hpEmailSignUp]').on('keydown', function(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();

      const emailId = $(this).val();
      const reg = /^[A-Za-z0-9][\w\-\+%]*(\.[\w\-\+%]+)*@[A-Za-z0-9]([\w\.\-]*[A-Za-z0-9])?\.[A-Za-z]{2,}$/;

      if (reg.test(emailId)) {
        if ($(this).next('span').length === 0) {
          $('<span></span>').insertAfter(this);
        }
        $(this).next('span').removeClass('invalid').addClass('valid');
        $('.email-input-box').find('.error-container .error').remove();
        $('.subscribe-email').trigger('click');
      } else {
        $(this).next('span').removeClass('valid').addClass('invalid');

        clientSideValidation.validateFormonBlur.call(this);
      }
    }
  });

};
